import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Modal, ModalBody} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import * as vignetsActions from "../../actions/vignets";
import {withRouter} from 'react-router';
import * as uploadReducers from "../../reducers/upload";


class VignetNewItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            vname_class : '',
            vtags_class : '',
            vignet_name: '',
            vignet_tags: '',
            vignet_desc :'',
            modal: false,
            redirect: false,
            builderState : false,
            builderUrl : '',
            image_path: null,
            userDet : JSON.parse(window.localStorage.userDet)

        };

        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showBuilder = this.showBuilder.bind(this);
        this.hideBuilder = this.hideBuilder.bind(this);

    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            image_path: null,
            vignet_name : '',
            vignet_desc : '',
            vignet_tag : ''
        });
    }

    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        console.log(this.state.image_path+"========= thi.state.iamgepath");
    }

    showBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : true
        });
        this.handleSubmit(e, this.state.builderState);
    }

    hideBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : false
        });
        this.handleSubmit(e, this.state.builderState);
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
    }

    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        if( this.state.vignet_name === '') {
            formInvalid++;
            document.getElementsByName('vignet_name')[0].classList.add('is-invalid');
        }

        if( formInvalid === 0) {

            var vigData = { userid : this.state.userDet.user_id ,title :this.state.vignet_name, vig_image : this.state.image_path, description: this.state.vignet_desc ,tags: this.state.vignet_tags};

            let vigCreated = this.props.createVignet(vigData);
            console.log(vigCreated);
            this.props.forceUpdateHandler();
            this.toggle();


        }
    }

    render() {

        return (

            <div className="panel-block new-panel" onClick={this.toggle}>

                <div className="gallery-thumb">
                    <div className="new-button-block">
                        <button className="icon-lib add-button"></button>
                        <p>Add Vignet</p>
                    </div>
                </div>



                <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop create-new-pop">
                    <ModalBody>
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                                    <h4 className="modal-title icon-lib title-icon">Add Vignets</h4>
                                </form>
                            </div>
                            <div className="modal-adduser-content">
                                <div className="modal-adduser-content-left">
                                    <div className="modal-adduser-detail">
                                        <p>TITLE</p>
                                        <div className="input-select">
                                            <input type="text" name="vignet_name" id="vignet_name" placeholder="Title" className="input-box without-ico" onChange={this.handleInputChange} valid={false} />
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>DESCRIPTION</p>
                                        <div className="input-select medium-desc-area">
                                            <textarea type="textarea"  className="form-text" name="vignet_desc" id="vignet_desc"   placeholder="Description" onChange={this.handleInputChange} valid={false}/>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>TAGS</p>
                                        <div className="input-select medium-desc-area">
                                            <textarea type="textarea" name="vignet_tags" className="form-text" id="vignet_tags"  placeholder="Tags" onChange={this.handleInputChange} valid={false}/>
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-adduser-content-right">
                                    <div className="modal-adduser-detail">
                                        <div className="modal-adduser-img">
                                            <div className="image-up">

                                                {this.state.image_path &&
                                                <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="vignet"/>
                                                }
                                                {this.state.image_path ===null &&
                                                <img src="assets/images/placeholder.png" alt="default" />
                                                }

                                                <UploadFile getUploadedFile={ this.getUploadedFile.bind(this)} type="add" item_type="VIGNETS" unique_id = ""/>
                                                {(this.state.image_path ===null || this.props.uploadData.loader === true) &&
                                                <div id="progress-bar-wrapper"></div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-adduser-content-btn">
                                    <div className="modal-btn btn-cancel">
                                        <a href="javascript:void(0);" className="" onClick={this.toggle}>CANCEL</a>
                                    </div>
                                    <div  className="modal-btn btn-create">
                                        <a href="javascript:void(0);" className="" onClick = {(e) => this.handleSubmit(e)}>SAVE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    {/*<ModalFooter>
                        <FormGroup className="pull-right button-gp">
                            <Button name="submit_form" type="button" color="info" className="gen-button" onClick = {(e) => this.handleSubmit(e)} >Save</Button>
                        </FormGroup>
                    </ModalFooter>*/}
                </Modal>

            </div>
    );
    }
}

VignetNewItem.propTypes = {
    completed: PropTypes.number
}

function mapStateToProps(state) {
    return {
        uploadData : uploadReducers.getUploadData(state)
    };
}

export default  withRouter(connect(mapStateToProps, {
    createVignet : vignetsActions.createVignet
})(VignetNewItem));



// WEBPACK FOOTER //
// ./src/components/vignets/VignetNewItem.js